module.exports = __webpack_public_path__ + "static/img/til54.ced85e3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/til54.png
// module id = 9fG2
// module chunks = 1